module.exports = __webpack_public_path__ + "img/keluar.4f93bc30.svg";